import React from 'react';
import appTypes from '../../../../constants/types';
import SectionCard from '../../../../components/section-card';
import { TextDataField } from '../../../../components/data-fields';
import { silverRoles } from '../../../../constants/silver';

export const SnipeCheckoutAssetDetails = ({ ticket }) => (
  <SectionCard title="Account information">
    <TextDataField
      name="Email"
      value={ticket && ticket.ticket_data.email} />
    <TextDataField
      name="Asset ID"
      value={ticket && ticket.ticket_data.asset_id} />
  </SectionCard>
);

SnipeCheckoutAssetDetails.propTypes = {
  ticket: appTypes.ticket.props,
};
SnipeCheckoutAssetDetails.defaultProps = {
  ticket: appTypes.ticket.default,
};
